import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { CustomerItem, TypeaheadService } from '../../../services/typeahead.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-skills-certificate',
  templateUrl: './skills-certificate.component.html',
  styleUrls: ['./skills-certificate.component.css']
})
export class SkillsCertificateComponent implements OnInit {
    labourNo;

    skillsCertificateKeyno;

    public edit?: Edit;

    public selectListSkillsCertificateTypes: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private typeahead: TypeaheadService) {
        this.labourNo = this.stateService.getStateParams()['labour_no'];
        this.skillsCertificateKeyno = this.stateService.getStateParams()['skillscertificate_keyno'];
    }

    private async loadEdit() {
        if (!!this.labourNo && !!this.skillsCertificateKeyno) {
            this.edit = (await this.datatask.Post(2502, {
                labour_no: this.labourNo,
                skillscertificate_keyno: this.skillsCertificateKeyno
            }))[0];
        }
    }

    private async loadSkillsCertificateTypes() {
        this.selectListSkillsCertificateTypes = await this.datatask.Post(2503);
    }

    public searchIssuerCustomerNames = () => {
        return this.typeahead.searchCustomer({
            cust_name: this.edit!.issuer_cust_name,
            custtype: 'S',
            lastselect: 'SEARCH'
        });
    }

    public onIssuerCustomerNameSelected(event?: CustomerItem) {
        if (!this.edit) return;

        this.edit.issuer_cust_no = !!event ? '' + event.item_id : '0';
        this.edit.issuer_cust_name = event?.item_name ?? '';
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2504, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public saveBeforeGoTo = async () => {
        if (!!this.edit) {
            const response = (await this.datatask.Post(2504, this.edit))[0];

            if (response?.errorcode !== '0') {
                this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.errormessage
                });
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadSkillsCertificateTypes();
    }

    ngOnInit() {
        this.init();
    }

}

interface Edit {
    skillscertificate_keyno: string;
    skillscertificatetype_keyno: string;
    labour_no: string;
    labour_name: string;
    valid_from_date: string;
    valid_until_date: string;
    issuer_cust_no: string;
    issuer_cust_name: string;
    note: string;
    course_start_date: string;
    course_end_date: string;
    reg_datetime: string;
    mod_datetime: string;
    reg_by_portal_user_name: string;
    mod_by_portal_user_name: string;
    nbr_of_documents: string;
    nbr_of_pictures: string;
    nbr_of_checklistdatas: string;
    certificate_id: string;
}
